<template>
  <div>
 
    <section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>

<!-- 
    <section class="goalsperfsec">
      <div class="upcomingeventsdiv">
        
        <div class="row align-items-start">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <PresentationSection :presentdata="presentdata" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 formatrightcol">
            <div class="eventtitles">UPCOMING EVENTS</div>
            <EventspanelCollapsible :eventdata="upcomingevents" :accodionid="1" />
          </div>
        </div>
      </div>
    </section> -->

  <!-- <section class="pastevents">
    <div class="col-xs-12 col-sm-12 col-md-12 pastevents">
      <div  class="eventtitles">PAST EVENTS</div>
      <EventspanelCollapsible :eventdata="pastevents" :accodionid="2"/>
    </div>
  </section> -->
   
  </div>
</template>

<script>

import PresentationSection from '@/components/PresentationSection.vue';
import EventspanelCollapsible from '@/components/EventspanelCollapsible.vue';

require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';
import moment from 'moment';



export default {
  name: 'AboutView',
  components: {
  PresentationSection, EventspanelCollapsible
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',


  breadcrumbsinfo: [],

  copymsg: '',

  presentdata: [],
  upcomingevents: [],
  pastevents: [],
  }
},
methods: {
  //method to format dates. please install moment using npm i moment
  async dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  },
async mounted() {
  this.myPicUrl = myUrlPath
  

   await axios.get('allpagespv/eventpresent').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

       if (this.pvisvideo === true) {
          this.src = this.videoimage.pvsrc
        }
        else {
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -20.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.7,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
      })
      .catch((error) => {
          console.log(error)
        })


  //------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/eventpresent').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })

  //------------upcoming presentation---------------
  axios.get('geteventcaption/eventpresent').then(
    response => {
        this.presentdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

   //------------upcoming events filter---------------
   axios.get('getupcomingevents/eventpresent').then(
    response => {
        this.upcomingevents = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //------------upcoming events past events---------------
  axios.get('getpastevents/eventpresent').then(
    response => {
        this.pastevents = response.data
    })
  .catch((error) => {
      console.log(error)
    })

    
}
}
</script>

<style scoped>


.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}


.pastevents {
  background-color: rgb(219, 222, 226);
}

.goalsperfsec {
  margin-top: 250px;
}

.eventtitles {
  font-weight: bold;
  font-size: 26px;
  padding-left: 30px;
  color: rgb(119, 142, 151);
  padding-bottom: 5px;
  padding-top: 40px;
}

.breadcrumbcss {
  height: 200px;
}


.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

  .pastevents {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .upcomingeventsdiv {
    padding-left: 15px;
    padding-right: 15px;
  }
  .formatrightcol {
    padding-bottom: 40px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 
   .pastevents {
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 50px;
     padding-bottom: 50px;
   }
   .upcomingeventsdiv {
     padding-left: 15px;
     padding-right: 15px;
   }
   .formatrightcol {
     padding-bottom: 40px;
   }

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

 }

 /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
   .pastevents {
     padding-left: 80px;
     padding-right: 80px;
     padding-top: 50px;
     padding-bottom: 50px;
   }
   .upcomingeventsdiv {
     padding-left: 80px;
     padding-right: 80px;
   }
   .formatrightcol {
     padding-bottom: 40px;
   }

 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .pastevents {
    padding-left: 100px;
    padding-right: 100px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .upcomingeventsdiv {
    padding-left: 200px;
    padding-right: 200px;
  }

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

  
@media only screen and (min-width: 1600px) {

  } 
</style>
